import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Button, Form, Icon, Ref, Table } from 'semantic-ui-react'
import { FromTo } from '../../../utils/FormSelectHelper'
import { observer } from 'mobx-react'

@observer
class TableDnD extends Component {
  static propTypes = {
    formEntry: PropTypes.instanceOf(FormEntry).isRequired,
    totalRowLabel: PropTypes.string.isRequired,
    headers: PropTypes.array,
    staticRows: PropTypes.any,
    minimumRows: PropTypes.number,
    fields: PropTypes.array.isRequired,
    startingRowIndex: PropTypes.number,
    droppableKey: PropTypes.string.isRequired,
    addRowLabel: PropTypes.string,
    tableProps: PropTypes.object
  }

  static defaultProp = {
    tableProps: {}
  }

  state = {
    addRowCount: '1'
  }

  handleAddRow = () => {
    const { formEntry: equipment, totalRowLabel } = this.props
    const { addRowCount } = this.state
    const totalRows = parseInt(equipment.getValue(totalRowLabel, false, 1))
    const newTotalRows = totalRows + parseInt(addRowCount)
    equipment.updateValue(totalRowLabel, newTotalRows)
  }

  addRow (index) {
    const { formEntry: equipment, totalRowLabel, fields } = this.props
    const totalRows = parseInt(equipment.getValue(totalRowLabel, false, 1))
    equipment.updateValue(totalRowLabel, totalRows + 1)
    this.reorderRows(totalRows, index)
    for (const field of fields) {
      equipment.updateValue(`${field.props.name}${index + 1}`, '')
    }
  }

  deleteRow (index) {
    const { formEntry: equipment, totalRowLabel } = this.props
    const totalRows = parseInt(equipment.getValue(totalRowLabel, false, 1))
    if (totalRows <= 1) {
      return
    }
    this.reorderRows(index, totalRows - 1)
    equipment.updateValue(totalRowLabel, totalRows - 1)
  }

  reorderRows (startIndex, endIndex) {
    const { formEntry: equipment, fields } = this.props
    if (startIndex < endIndex) {
      for (let i = startIndex; i < endIndex; i++) {
        for (const field of fields) {
          equipment.updateValue(`${field.props.name}${i}`, equipment.getValue(`${field.props.name}${i + 1}`))
        }
      }
    } else {
      for (let i = startIndex; i > endIndex; i--) {
        for (const field of fields) {
          equipment.updateValue(`${field.props.name}${i}`, equipment.getValue(`${field.props.name}${i - 1}`))
        }
      }
    }
  }

  handleDragEnd = ({ source, destination }) => {
    if (!destination) {
      return
    }
    const { formEntry: equipment, fields } = this.props
    const sourceData = {}
    for (const field of fields) {
      sourceData[field.props.name] = equipment.getValue(`${field.props.name}${source.index}`)
    }

    this.reorderRows(source.index, destination.index)
    for (const field of fields) {
      equipment.updateValue(`${field.props.name}${destination.index}`, sourceData[field.props.name])
    }
  }

  render () {
    const { formEntry: equipment, totalRowLabel, headers, staticRows, fields, droppableKey, tableProps, addRowLabel, startingRowIndex, minimumRows } = this.props
    const { addRowCount } = this.state
    const totalRows = parseInt(equipment.getValue(totalRowLabel, false, minimumRows || 1))
    if (equipment.readonly) {
      return (
        <>
          <Table {...tableProps}>
            {headers &&
              <Table.Header>
                <Table.Row>
                  {headers.map((header) => (
                    <Table.HeaderCell key={header.key || header.label} {...header.props}>
                      {header.label}
                    </Table.HeaderCell>
                  ))}
                </Table.Row>
              </Table.Header>}
            {staticRows &&
              <Table.Body>
                {staticRows.map((row, index) => (
                  <Table.Row key={`static_${droppableKey}_${index}`}>
                    {row}
                  </Table.Row>
                ))}
              </Table.Body>}
            <Table.Body>
              {[...Array(totalRows).keys()].map((item, index) => {
                const rowIndex = startingRowIndex ? startingRowIndex + index : index
                return (
                  <Table.Row key={`${droppableKey}_${rowIndex}`}>
                    {fields.map(field => {
                      const { name, ...rest } = field.props
                      if (field.fieldType === 'strong') {
                        return (
                          <Table.Cell key={`${name}${rowIndex}`} {...field.cellProps}>
                            {React.createElement(field.fieldType, {}, `${field.props.prefix}${rowIndex}`)}
                          </Table.Cell>
                        )
                      }
                      return (
                        <Table.Cell key={`${name}${rowIndex}`} {...field.cellProps}>
                          {React.createElement(field.fieldType, {
                            ...rest,
                            name: `${name}${rowIndex}`,
                            formEntry: equipment
                          })}
                        </Table.Cell>
                      )
                    })}
                  </Table.Row>
                )
              })}
            </Table.Body>
          </Table>
        </>
      )
    }
    return (
      <>
        {addRowLabel && (
          <div className='compact'>
            <Form.Select options={FromTo(1, 100)} label={addRowLabel} value={addRowCount} width={6} onChange={(e, { value }) => { this.setState({ addRowCount: value }) }} />
            <Button icon name='add' onClick={this.handleAddRow} content='Ajouter' />
          </div>

        )}
        <DragDropContext onDragEnd={this.handleDragEnd}>
          <Table {...tableProps}>
            {headers &&
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell style={{ minWidth: '60px', width: '60px', maxWidth: '60px' }} />
                  <Table.HeaderCell style={{ minWidth: '20px', width: '20px', maxWidth: '20px' }} />
                  {headers.map((header) => (
                    <Table.HeaderCell
                      key={header.key || header.label}
                      {...header.props}
                    >{header.label}
                    </Table.HeaderCell>
                  ))}
                </Table.Row>
              </Table.Header>}
            {staticRows &&
              <Table.Body>
                {staticRows.map((row, index) => (
                  <Table.Row key={`static_${droppableKey}_${index}`}>
                    <Table.Cell />
                    <Table.Cell />
                    {row}
                  </Table.Row>
                ))}
              </Table.Body>}
            <Droppable droppableId={droppableKey}>
              {(provided) => (
                <Ref innerRef={provided.innerRef}>
                  <Table.Body {...provided.droppableProps}>
                    {[...Array(totalRows).keys()].map((item, index) => {
                      const rowIndex = startingRowIndex ? startingRowIndex + index : index
                      return (
                        <Draggable
                          key={`${droppableKey}_${rowIndex}`} draggableId={`${droppableKey}_${rowIndex}`}
                          index={rowIndex}
                        >
                          {(provided, snapshot) => (
                            <Ref innerRef={provided.innerRef}>
                              <Table.Row {...provided.draggableProps}>
                                <Table.Cell textAlign='center'>
                                  <Icon name='add' onClick={() => this.addRow(rowIndex)} />
                                  <Icon name='trash' onClick={() => this.deleteRow(rowIndex)} />
                                </Table.Cell>
                                <Table.Cell {...provided.dragHandleProps} textAlign='center'>
                                  <Icon
                                    name='arrows alternate vertical'
                                  />
                                </Table.Cell>
                                {fields.map(field => {
                                  const { name, ...rest } = field.props
                                  if (field.fieldType === 'strong') {
                                    return (
                                      <Table.Cell key={`${name}${rowIndex}`} {...field.cellProps}>
                                        {React.createElement(field.fieldType, {}, `${field.props.prefix}${rowIndex}`)}
                                      </Table.Cell>
                                    )
                                  }
                                  return (
                                    <Table.Cell key={`${name}${rowIndex}`} {...field.cellProps}>
                                      {React.createElement(field.fieldType, {
                                        ...rest,
                                        name: `${name}${rowIndex}`,
                                        formEntry: equipment
                                      })}
                                    </Table.Cell>
                                  )
                                })}
                              </Table.Row>
                            </Ref>
                          )}
                        </Draggable>
                      )
                    })}
                    {provided.placeholder}
                  </Table.Body>
                </Ref>
              )}
            </Droppable>
          </Table>
        </DragDropContext>
      </>
    )
  }
}

export default TableDnD
